import notificationBlue from '../assets/icons/notification_blue.png'
import { useEffect, useState } from 'react';
import { title } from '../utils/style';

function Notification({ showNotification, setShowNotification }) {
    const [ notifications, setNotifications ] = useState([])

    useEffect(() => {
        indexedDB.databases()
        .then(dbs => {
            const db = dbs.filter(db => db.name === 'notifications-db')
            if(db.length > 0) {
                getStoredNotifications().then((fetchedNotifications) => {
                    setNotifications(fetchedNotifications);
                });
            }
        })
    }, [showNotification])


    function getStoredNotifications() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open('notifications-db', 1);
        
            request.onsuccess = function(event) {
                const db = event.target.result;
                const transaction = db.transaction(['notifications'], 'readonly');
                const store = transaction.objectStore('notifications');
                const getAll = store.getAll();
        
                getAll.onsuccess = function() {
                resolve(getAll.result);
                };
        
                getAll.onerror = function() {
                reject('Error retrieving notifications');
                };
            };
        
            request.onerror = function() {
                reject('Error opening database');
            };
        });
    };

    
    function clearIndexedDBData(dbName, storeName) {
        let request = indexedDB.open(dbName);
    
        request.onsuccess = function(event) {
        let db = event.target.result;
        let transaction = db.transaction([storeName], 'readwrite');
        let objectStore = transaction.objectStore(storeName);
    
        let clearRequest = objectStore.clear();
    
        clearRequest.onsuccess = function() {
            console.log('All data deleted from the object store:', storeName);
            setShowNotification(false)
        };
    
        clearRequest.onerror = function(event) {
            console.error('Error clearing data from object store:', event.target.errorCode);
        };
        };
    
        request.onerror = function(event) {
        console.error('Database error:', event.target.errorCode);
        };
    }

    return(
        <div className={`flex fixed top-0 right-0 rounded-md z-50 transition-all duration-5 0 ease-in-out ${showNotification ? 'w-full' : 'w-0'}`}>
            <div className='flex-1 bg-black opacity-50 ' onClick={() => setShowNotification(false)}></div>
            <div className='flex flex-col w-2/3 gap-2 bg-white h-screen max-h-screen p-4 overflow-scroll scroll-auto pb-14'>
                <div className='flex justify-between items-center'>
                    <div className={title + ' ' + 'text-customOne'}>Notification</div>
                    <div className='text-customOne text-sm font-semibold cursor-pointer' onClick={() => clearIndexedDBData('notifications-db', 'notifications')}>Clear</div>
                </div>
                {
                    notifications.reverse().map((notification, ind) => ind < 10 &&
                        <div className='bg-[#CDE0F1] rounded-lg p-4' key={ind}>
                            <div className='flex gap-4 text-customOne items-center rounded-lg'>
                                <img src={notificationBlue} width={20} height={20}/>
                                <span className='text-sm font-semibold'>{notification.title}</span>
                            </div>
                            <div className='text-xs font-semibold'>{notification.body}</div>
                        </div>
                    )
                }
            </div>
        </div>
    )
} 
export default Notification;